import { render, staticRenderFns } from "./SensorsButtons.vue?vue&type=template&id=ef9fcbd0"
import script from "./SensorsButtons.vue?vue&type=script&lang=js"
export * from "./SensorsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports